import { render, staticRenderFns } from "./c_checkout_hot.vue?vue&type=template&id=4673aa49&scoped=true"
import script from "./c_checkout_hot.vue?vue&type=script&lang=js"
export * from "./c_checkout_hot.vue?vue&type=script&lang=js"
import style0 from "./c_checkout_hot.vue?vue&type=style&index=0&id=4673aa49&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673aa49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4673aa49')) {
      api.createRecord('4673aa49', component.options)
    } else {
      api.reload('4673aa49', component.options)
    }
    module.hot.accept("./c_checkout_hot.vue?vue&type=template&id=4673aa49&scoped=true", function () {
      api.rerender('4673aa49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_checkout_hot.vue"
export default component.exports